import React from "react";
import { Link } from "react-router-dom"; // Import Link for navigation
import { FiFacebook, FiTwitter, FiInstagram, FiLinkedin } from "react-icons/fi";
import ScrollAnimation from "react-animate-on-scroll";
import teamData from "../../data/consultation/Consultant.json"; // Import JSON directly

const iconMapping = {
    facebook: <FiFacebook />,
    twitter: <FiTwitter />,
    instagram: <FiInstagram />,
    linkedin: <FiLinkedin />
};

const Consultant = ({ column, teamStyle }) => {
    return (
        <div>
            <div className="row row--15">
                {teamData.map((data, index) => (
                    <div className={`${column}`} key={index}>
                        <div className={`rn-team ${teamStyle}`}>
                            <ScrollAnimation animateIn="fadeInUp" animateOut="fadeInOut" animateOnce={true}>
                                <div className="inner">
                                    <figure className="thumbnail">
                                        <img src={`./images/consultation/profile/${data.image}.jpg`} alt="Team Member" />
                                    </figure>
                                    <figcaption className="content">
                                        <h2 className="title">{data.name}</h2>
                                        <h6 className="subtitle theme-gradient">{data.designation}</h6>
                                        <span className="team-form">
                                            <img src="./images/team/location.svg" alt="Location Icon" />
                                            <span className="location">{data.location}</span>
                                        </span>
                                        <p className="description">{data.description}</p>
                                        <ul className="social-icon social-default icon-naked mt--20">
                                            {data.socialNetwork.map((social, index) => (
                                                <li key={index}>
                                                    <a href={social.url}>{iconMapping[social.icon]}</a>
                                                </li>
                                            ))}
                                        </ul>

                                        {/* View Profile Button */}
                                        <div className="text-center mt--20">
                                            <Link to={`/consultant/${data.id}`} className="btn-default text-underline">
                                                View Profile
                                            </Link>
                                        </div>
                                    </figcaption>
                                </div>
                            </ScrollAnimation>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Consultant;
